import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves program for currencies
 * @param {object} _this: context variables
 * @param {string} fieldName: name of the variable in the view where data will be stored
 * @param {string} fieldShowLoadingName: show loading variable name
 */

export function getCurrencyProgram(_this, fieldName, fieldShowLoadingName) {
  _this[fieldShowLoadingName] = true;
  gatewayService.currencies
    .program({
      format: "json",
      currency: parseInt(_this.currencyNumber),
      portfolios: JSON.stringify({ id_portfolios: _this.portfolioNumbers })
    })
    .then(data => {
      if (
        _this.modal_processing_message !== undefined &&
        data.length > 0
      ) {
        let localData = [];
        let hTot = 0;
        _this.radioSelection = data[0].objective.toLowerCase();
        if (data[0].objective === "Balance") {
          _this.selectedBalGradient = data[0].parameters;
          if (_this.selectedBalGradient === "monthly") {
            data.map(function(d) {
              _this.balanceMonths = Object.keys(d.flow.values).length;
              _this.exampleDataRaw.forEach(function(b) {
                if (b.id < _this.balanceMonths) {
                  localData.push({
                    id: b.id,
                    date: "",
                    balance: b.balance,
                    cashFlow: b.cashFlow,
                    hedge:
                      (d.flow.values[b.id] / 100) * (b.balance + b.cashFlow),
                    percentage: d.flow.values[b.id]
                  });
                }
              });
            });
            hTot = localData.map(d => d.hedge).reduce((a, b) => a + b);
            _this.balanceTotal = _this.exampleDataRaw
              .map(d => d.balance)
              .reduce((a, b) => a + b);
            _this.balancePercentage = Math.round(
              (100 * hTot) / _this.balanceTotal
            );
          }
          if (_this.selectedCashFlowGradient === "quarterly") {
            data.map(function(d) {
              _this.cashFlowMonths = Object.keys(d.flow.values).length * 3;
              let array_percentages = [];
              for (let i in d.flow.values) {
                array_percentages.push(d.flow.values[i]);
              }
              let count = 0;
              _this.exampleDataRaw.forEach(function(b) {
                if (b.id < _this.cashFlowMonths) {
                  if (b.id % 3 === 0 && b.id !== 0) {
                    count = count + 1;
                  }
                  localData.push({
                    id: b.id,
                    date: "",
                    balance: b.balance,
                    cashFlow: b.cashFlow,
                    hedge:
                      (array_percentages[count] / 100) *
                      (b.balance + b.cashFlow),
                    percentage: array_percentages[count]
                  });
                }
              });
            });
            hTot = localData.map(d => d.hedge).reduce((a, b) => a + b);
            _this.balanceTotal = _this.exampleDataRaw
              .map(d => d.balance)
              .reduce((a, b) => a + b);
            _this.balancePercentage = Math.round(
              (100 * hTot) / _this.balanceTotal
            );
          }
          if (_this.selectedBalGradient === "match") {
            data.map(function(d) {
              _this.balancePercentage = d.flow.values.percentage;
            });
          }
          if (_this.selectedBalGradient === "constant") {
            data.map(function(d) {
              _this.balanceMonths = d.flow.values.months;
              _this.balancePercentage = d.flow.values.percentage;
            });
          }
        } else {
          let localData = [];
          _this.selectedCashFlowGradient = data[0].parameters;
          if (_this.selectedCashFlowGradient === "monthly") {
            data.map(function(d) {
              _this.cashFlowMonths = Object.keys(d.flow.values).length;
              _this.exampleDataRaw.forEach(function(b) {
                if (b.id < _this.cashFlowMonths) {
                  localData.push({
                    id: b.id,
                    date: "",
                    balance: b.balance,
                    cashFlow: b.cashFlow,
                    hedge:
                      (d.flow.values[b.id] / 100) * (b.balance + b.cashFlow),
                    percentage: d.flow.values[b.id]
                  });
                }
              });
            });
            hTot = localData.map(d => d.hedge).reduce((a, b) => a + b);
            _this.balanceTotal = _this.exampleDataRaw
              .map(d => d.balance)
              .reduce((a, b) => a + b);
            _this.cashFlowTotal = _this.exampleDataRaw
              .map(d => d.cashFlow)
              .filter((d, i) => i < _this.cashFlowMonths)
              .reduce((a, b) => a + b);
            _this.cashFlowPercentage = Math.round(
              (100 * hTot) / (_this.balanceTotal + _this.cashFlowTotal)
            );
            localData.forEach(function(d, i) {
              d.date = new Date(
                _this.now.getFullYear(),
                _this.now.getMonth() + i + 1,
                1
              );
            });
            _this.exampleData = localData;
            _this.db = true;
          }
          if (_this.selectedCashFlowGradient === "quarterly") {
            data.map(function(d) {
              _this.cashFlowMonths = Object.keys(d.flow.values).length * 3;
              let array_percentages = [];
              for (let i in d.flow.values) {
                array_percentages.push(d.flow.values[i]);
              }
              let count = 0;
              _this.exampleDataRaw.forEach(function(b) {
                if (b.id < _this.cashFlowMonths) {
                  if (b.id % 3 === 0 && b.id !== 0) {
                    count = count + 1;
                  }
                  localData.push({
                    id: b.id,
                    date: "",
                    balance: b.balance,
                    cashFlow: b.cashFlow,
                    hedge:
                      (array_percentages[count] / 100) *
                      (b.balance + b.cashFlow),
                    percentage: array_percentages[count]
                  });
                }
              });
            });
            hTot = localData.map(d => d.hedge).reduce((a, b) => a + b);
            _this.balanceTotal = _this.exampleDataRaw
              .map(d => d.balance)
              .reduce((a, b) => a + b);
            _this.cashFlowTotal = _this.exampleDataRaw
              .map(d => d.cashFlow)
              .filter((d, i) => i < _this.cashFlowMonths)
              .reduce((a, b) => a + b);
            _this.cashFlowPercentage = Math.round(
              (100 * hTot) / (_this.balanceTotal + _this.cashFlowTotal)
            );
            localData.forEach(function(d, i) {
              d.date = new Date(
                _this.now.getFullYear(),
                _this.now.getMonth() + i + 1,
                1
              );
            });
            _this.exampleData = localData;
          }
          if (_this.selectedCashFlowGradient === "budget") {
            data.map(function(d) {
              _this.cashFlowBudgetMonth = d.flow.values.percentagemonths;
              _this.cashFlowPercentage = d.flow.values.percentage;
            });
          }
          if (_this.selectedCashFlowGradient === "constant") {
            data.map(function(d) {
              _this.cashFlowMonths = d.flow.values.months;
              _this.cashFlowPercentage = d.flow.values.percentage;
            });
          }
        }
        _this.modal_processing_message.showModalLoading = false;
      } else {
        if (typeof _this.programDataModel !== "undefined") {
          _this.modal_processing_message.messageModal =
            "No program found for this portfolio";
          _this.modal_processing_message.optionsModal = true;
        } else {
          data.forEach(function(d) {
            d.currency = d.fk_currency;
          });
          _this[fieldName] = data;
          _this[fieldShowLoadingName] = false;
        }
        _this.exampleData = {};
        _this.radioSelection = "balance";
        _this.db = false;
      }
    })
    .catch(function(error) {
      _this[fieldShowLoadingName] = false;
      console.error(error);
    });
}
